module.exports = __webpack_public_path__ + "assets/redpack-meteor-back-df05a4fd.png";